export default __webpack_public_path__ + "static/img4-e6a96dad1ca3711a98ce47f5b806bef7.webp";